import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const ButtonWrapperStyles = styled.section`
  border: 3px solid  ${props => props.theme.colors.accent1};
  border-radius: 10px;
  position: relative;
  margin: 20px auto;
  max-width: 350px;
  padding-bottom: 10px;
  font-weight: 700;
  padding-top: 30px;
  
  @media screen and (min-height: 569px) {
    padding-top: 0;
  }

  @media screen and (min-width: ${props => props.theme.breakpoints.med}) {
    width: 400px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 40px;
  }
`;

const ButtonWrapperLozenge = styled.section`
  background-color: ${props => props.theme.colors.accent1};
  width: 50%;
  border-radius: 15px;
  height: 30px;
  color: ${props => props.theme.colors.background};
  line-height: 30px;
  position: absolute;
  transform: translateX(-50%);
  left: 50%;
  top: -15px;
`;

const ButtonWrapperText = styled.p`
  display: none;
  margin: 30px 50px 15px 50px;

  @media(min-height:569px) {
    display: block;
  }
`;

const ButtonWrapper = props => (
  <ButtonWrapperStyles>
    <ButtonWrapperLozenge>Early Access</ButtonWrapperLozenge>
    <ButtonWrapperText >Tell us if our new elimination mode is any good!</ButtonWrapperText >
    {props.children}
  </ButtonWrapperStyles>
);

export default ButtonWrapper;

ButtonWrapper.propTypes = {
  children: PropTypes.any
}



// WEBPACK FOOTER //
// ./src/components/button-wrapper/buttonWrapper.js